import script from "./checklist.vue?vue&type=script&setup=true&lang=js"
export * from "./checklist.vue?vue&type=script&setup=true&lang=js"

import "./checklist.vue?vue&type=style&index=0&id=7f987d42&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f987d42"]])

export default __exports__